module.exports = __webpack_public_path__ + "img/mirta-logo.cc60ee77.png";